import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Testimonial2 from "./Testimonial2";



import testimonial1 from "../../Assets/syepMain.png";
import testimonial2 from "../../Assets/gradSYEP.png";
import testimonial3 from "../../Assets/syep_2025.jpeg";
import testimonial4 from "../../Assets/Choicest_Fruit.png";




// Import slick-carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";




const sliderImages = [
  { src: testimonial1, alt: "testimonials" },
  { src: testimonial2, alt: "testimonials" },
  { src: testimonial3, alt: "testimonials" },
  { src: testimonial4, alt: "testimonials" },




  // Add more images as needed

  ];


function Testimonial() {
 



  // Settings for the Slick slider
  const settings = {
    dots: false, // Dots are globally hidden in CSS
    infinite: true, // Infinite loop
    speed: 500, // Transition speed in ms
    slidesToShow: 1, // Show one image at a time
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3500, // Time between slides in ms
  };



  return (
    <Container fluid className="about-section testimonials-page">
      <Particle />
      <Container className="testimonials-container">
        <header className="testimonials-hero">
          <h1 className="testimonials-hero-title">
            Testimonials
          </h1>
          <p className="testimonials-hero-lead">
            What participants say about learning, growth, and real-world impact at Choicest Fruit.
          </p>
        </header>

        <Row className="testimonials-top" style={{ justifyContent: "center" }}>
          <Col md={12}>
            <div className="policy-card testimonials-slider-card" aria-label="Program highlights">
              <Slider {...settings}>
                {sliderImages.map((image, index) => (
                  <div key={index} className="testimonials-slide">
                    <img src={image.src} alt={image.alt} className="testimonials-slide-img" />
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>

        <Testimonial2 />
      </Container>
    </Container>
  );
}

export default Testimonial;
